export default {
    topics: [
        {
            title: ' addCookie ',
            href: 'm-HttpServletResponse-addCookie.html',
            attributes: { 'data-id': 'm-HttpServletResponse-addCookie' },
            menu: { hasChildren: false },
            tocID: 'm-HttpServletResponse-addCookie-d66e7847',
            topics: [],
        },
        {
            title: ' addHeader ',
            href: 'm-HttpServletResponse-addHeader.html',
            attributes: { 'data-id': 'm-HttpServletResponse-addHeader' },
            menu: { hasChildren: false },
            tocID: 'm-HttpServletResponse-addHeader-d66e7855',
            topics: [],
        },
        {
            title: ' sendError ',
            href: 'm-HttpServletResponse-sendError.html',
            attributes: { 'data-id': 'm-HttpServletResponse-sendError' },
            menu: { hasChildren: false },
            tocID: 'm-HttpServletResponse-sendError-d66e7863',
            topics: [],
        },
        {
            title: ' sendRedirect ',
            href: 'm-HttpServletResponse-sendRedirect.html',
            attributes: { 'data-id': 'm-HttpServletResponse-sendRedirect' },
            menu: { hasChildren: false },
            tocID: 'm-HttpServletResponse-sendRedirect-d66e7871',
            topics: [],
        },
        {
            title: ' setContentType ',
            href: 'm-HttpServletResponse-setContentType.html',
            attributes: { 'data-id': 'm-HttpServletResponse-setContentType' },
            menu: { hasChildren: false },
            tocID: 'm-HttpServletResponse-setContentType-d66e7879',
            topics: [],
        },
    ],
};

